import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MixpanelService } from '../_services';

@Component({
  template: `
<app-hero [heroImage]="'public-hero'" [pageTitle]="data.content.heading1"></app-hero>

<section id="content-section" class="container">

  <app-pagetitle [PageTitle]="data.content.heading1" [PageLeadPara]="data.content.para1"></app-pagetitle>

  <div class="row">
    <div class="col-12" [innerHtml]="data.content.content"></div>
  </div>

</section>
`
})
export class StaticPublicComponent implements OnInit, AfterViewInit {
  data: any = null;

  constructor(
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private titleService: Title,
    private mixpanelService: MixpanelService
  ) {}

  ngOnInit(): void {
    this.data = this.route.snapshot.data;
    this.data.content.content = this.sanitizer.bypassSecurityTrustHtml(this.data.content.content);
    this.mixpanelService.trackPageView(this.data.content.windowTitle);
    this.titleService.setTitle(this.data.content.windowTitle);
  }

  ngAfterViewInit(): void {
    // Fix for anchor links in static content
    // https://stackoverflow.com/a/20096902
    const path = window && window.location && window.location.pathname;
    if (typeof path === 'string') {
      Array.from(document.querySelectorAll('a[href^="#"]')).forEach((link) => {
        const href = link.getAttribute('href');
        link.setAttribute('href', path + href);
      });
    }

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // GK@20181031 fix for the issue where hash links are not scrolled into
    // view on document load
    if (window.location.hash) {
      const elAnchor = document.querySelector(window.location.hash);
      if (elAnchor != null) {
        setTimeout(() => {
          elAnchor.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
      }
    }
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/static.component.ts